<template>
  <div class="footer">
    <div class="logo">
     <!-- <img src="../assets/logo_fuchs.svg" alt="Logo Fuchs Konzepte"> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {},
}
</script>

<style scoped>
.footer {
  margin: 50px 15px 0 15px;
}

.logo img {
  display: block;
  margin: 0 auto;
}
</style>
